const getDispenseType = state => {
  return state.dispenseTypeLookup;
};
const getDispenseBase = state => {
  return state.dispenseBaseLookup;
};
const getUOM = state => {
  return state.UOMLookup;
};
const getPackaging = state => {
  return state.packagingLookup;
};

export default {
  getDispenseType,
  getDispenseBase,
  getUOM,
  getPackaging,
};
